import React from "react";

const SkeletonCampaign = () => (
    <div className="campaign-result">
        <div className="campaign-box">
            <div className="campaign-header">
                <div className="skeleton skeleton-header"></div>
            </div>
            <div className="campaign-info">
                <div className="skeleton skeleton-thumbnail"></div>
                <div className="campaign-details">
                    <div className="skeleton skeleton-header"></div>
                    <div className="skeleton skeleton-detail"></div>
                    <div className="skeleton skeleton-detail"></div>
                </div>
            </div>
        </div>
    </div>
);

export default SkeletonCampaign;